import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';

import EmbededIframe from './EmbededIframe';

import Quote from '../images/quote1.svg';
import PodcastBackground from '../images/podcast-background.svg';

const SectionContainer = styled.section`
    color: white;
    overflow: hidden;
    position: relative;
    padding: 50px 0 70px;
    background-color: #6b717f;
    background: -moz-linear-gradient(left,  #6b717e 0%, #5b6477 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left,  #6b717e 0%,#5b6477 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right,  #6b717e 0%,#5b6477 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#6b717e', endColorstr='#5b6477',GradientType=1 ); /* IE6-9 */

    @media (min-width: 1150px) {
        padding: 50px 0 240px;
    }
    @media (min-width: 1440px) {
        padding: 50px 0 280px;
    }

    &::before {
        content: " ";
        display: block;
        bottom: 0;
        left: 0;
        position: absolute;
        width: 100%;
        height: 180px;
        background-position: center 0px;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url(${PodcastBackground});

        @media (min-width: 1440px) {
            height: 225px;
        }
    }
`
const QuoteImg = styled.img`
    max-width: 40px;
`
const PodcastContainer = styled.div`
    a {
        display: block;
        color: white;
        text-decoration: none;
    }
`

const Button = styled.button`
    color: white;
    border: none;
    padding: 10px;
    font-size: 20px;
    cursor: pointer;
    background: none;
    font-family: 'GrandDuke', 'Spectral', serif;
`

const Podcast = ({position}) => {
    const containerRef = useRef(null);
    const [showAll, setShowAll] = useState(false);
 
    useEffect(() => {
        const { current } = containerRef;

        position(current.offsetTop)
    })

    const toggleDisplay = () => {
        setShowAll(true);
    };

    return (
        <SectionContainer id="PodcastEpisodes" ref={containerRef}>
            <h2>Why not listen to our latest episode?</h2>
            <QuoteImg src={Quote} alt="speach mark"/>

            <PodcastContainer>
                <EmbededIframe toggle={showAll}/>

                <Button onClick={() => toggleDisplay()}>Or click here to have a look at all our episodes</Button>
            </PodcastContainer>

        </SectionContainer>
    );
};

export default Podcast;
